import moment from 'moment'

import { EmbeddedObject } from '@pages/ConfiduredGantt/types'

import { FIELD_VALUE_TYPE } from '@constants'
import { AutocompleteOption, ObjectFieldDTO } from '@types'

export const getFilterByValueType = (
  fieldName: string,
  isTyping: boolean,
  value: string,
  currentSelectedValue: string | AutocompleteOption | null | undefined,
  type: FIELD_VALUE_TYPE,
  objLinkField: ObjectFieldDTO | undefined,
  isRefDateField?: boolean,
  lastRefField?: EmbeddedObject
) => {
  const fullSearchPattern = `${fieldName}==${value}`
  const partialSearchPattern = `${fieldName}=='*${value}*'`
  const isPk = objLinkField?.isPk || lastRefField?.isPk

  if (!objLinkField) {
    return null
  }

  // Отключение фильтрации при уже выбранном значении поля
  if ((currentSelectedValue?.label === value || currentSelectedValue === value) && !isTyping)
    return null

  // Фильтр с '*' не работает по ref полям с displayed fieldName datetime
  if (isRefDateField) {
    return moment(value, moment.ISO_8601, true).isValid() ? fullSearchPattern : null // Добавил проверку на ISOString (В БД дата лежит именно в этом формате)
  }

  // Фильтр с '*' не работает по _id
  if (fieldName === objLinkField?.name || lastRefField?.isPk) {
    return isPk ? fullSearchPattern : partialSearchPattern
  }

  switch (type) {
    case FIELD_VALUE_TYPE.INTEGER:
      return fullSearchPattern
    default:
      return partialSearchPattern
  }
}
